module.exports = __webpack_public_path__ + "media/images/android-chrome-96x96-49de21d1a008d2be825491689abd9f15.png";